import script from "./AddingMainPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddingMainPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddingMainPage.vue?vue&type=style&index=0&id=fbdcadea&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbdcadea"]])

export default __exports__